import React, { useState, useEffect, useCallback } from 'react';
import { dashboardAPI } from '../services/api';
import DateFilter from '../components/DateFilter';

const fmt = (v) => new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', maximumFractionDigits: 0 }).format(v);

export default function PassengersPage() {
  const [passengers, setPassengers] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async (params = {}) => {
    setLoading(true);
    try {
      const res = await dashboardAPI.topPassengers({ ...params, limit: 50 });
      setPassengers(res.data);
    } catch (err) { console.error(err); }
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  if (loading && !passengers.length) return <div className="loading">Yükleniyor...</div>;

  return (
    <div>
      <div className="topbar">
        <h1>Yolcu Özeti</h1>
        <DateFilter onFilter={load} />
      </div>

      <div className="chart-card">
        <h3>Tüm Yolcular ({passengers.length} kişi)</h3>
        <div style={{ overflowX: 'auto' }}>
          <table className="data-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Yolcu Adı</th>
                <th>Uçak Bileti</th>
                <th>Otel</th>
                <th>Transfer</th>
                <th>Araç Kiralama</th>
                <th>Toplam</th>
                <th>İşlem Sayısı</th>
              </tr>
            </thead>
            <tbody>
              {passengers.map((p, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td style={{ fontWeight: 500 }}>{p.name}</td>
                  <td>{fmt(p.flight_total)}</td>
                  <td>{fmt(p.hotel_total)}</td>
                  <td>{fmt(p.transfer_total)}</td>
                  <td>{fmt(p.car_total)}</td>
                  <td style={{ fontWeight: 700, color: 'var(--primary)' }}>{fmt(p.grand_total)}</td>
                  <td>{p.transaction_count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
